export default __webpack_public_path__ + "assets/img/raspberrypi4.jpg";